import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { AppConstants } from "../constants/constants";
import { translation } from "../constants/DynamicTranslations";
import { translationsContentObject } from "../constants/DynamicTranslationContents";
@Pipe({
  name: "translateDynamic",
})
export class TranslateDynamicPipe implements PipeTransform {
  siteLanguageCode: string;
  constructor(@Inject(LOCALE_ID) protected localeId: string) {
    this.siteLanguageCode = this.localeId;
  }

  transform(value: string, isActivity: boolean = false, len:number = 0, split: string = AppConstants.BLANK): string {
    let result = this.siteLanguageCode === AppConstants.WELSH_LANG_CODE
      ? isActivity
        ? translationsContentObject[value] === undefined
          ? value
          : translationsContentObject[value]
        : translation[value] === undefined
        ? value
        : translation[value]
      : value;

    if (len > 0) {
      if (result && result.length > len) {
        result = result.substring(0, len) + AppConstants.ELLIPSIS;
      }
    }

    if (split !== AppConstants.BLANK) {
      const [first, second] = value.split(split).map((item) => item.trim());
    
      let joinResult = value;
      const spacedSplit = `${split}${AppConstants.SINGLE_SPACE}`;
    
      if (this.siteLanguageCode === AppConstants.WELSH_LANG_CODE) {
        joinResult = [
          translation[first] || first,
          translation[second] || second
        ].join(spacedSplit);
      }

      result = joinResult;
    }

    return result;
  }
}
